import { View, Text } from "@react-pdf/renderer";
import type { FC } from "react";
import type { KpiCardBlock } from "@/types/blocks";
import styles from "./pdfStyles";
import { resolveColor, fontSize } from "./pdfTokens";
import { formatCompactNumber } from "@/utils/formatCompactNumber";

interface PdfKpiCardProps {
  block: KpiCardBlock;
}

export const PdfKpiCard: FC<PdfKpiCardProps> = ({ block }) => {
  const count = block.items.length;
  const cols = count <= 2 ? count : count <= 3 ? 3 : count <= 4 ? 2 : 3;
  const cardWidth = cols === 1 ? "100%" : cols === 2 ? "48.5%" : "31.5%";

  return (
    <View>
      {block.title && <Text style={styles.blockTitle}>{block.title}</Text>}
      <View style={styles.kpiGrid}>
        {block.items.map((item, i) => {
          const accent = resolveColor(item.color);
          const value = formatCompactNumber(item.value);
          const delta = item.delta ? formatCompactNumber(item.delta) : null;
          const valLen = value.length;
          const valueFontSize =
            valLen > 30 ? fontSize.sm : valLen > 15 ? fontSize.md : fontSize.lg;

          return (
            <View key={i} style={[styles.kpiCard, { width: cardWidth }]}>
              <Text style={styles.kpiLabel}>{item.label}</Text>
              <Text style={[styles.kpiValue, { color: accent, fontSize: valueFontSize }]}>
                {value}
              </Text>
              {delta && (
                <Text style={[styles.kpiDelta, { color: accent, marginTop: 2 }]}>
                  {delta}
                </Text>
              )}
            </View>
          );
        })}
      </View>
    </View>
  );
};
